<div class="mobile-menu-wrap">
  <div class="mobile-menu-header d-flex align-items-center justify-content-end"
       [class.bg-primary]="fillBackground">
    <i class="icon-close font-xl p-3"
       [class.text-color-default]="!fillBackground"
       (click)="close()"></i>
  </div>

  <div class="mobile-menu">
    <ng-content></ng-content>
  </div>
</div>
